module.exports = __webpack_public_path__ + "img/bg.28f5556c.svg";